import React from 'react';
import { Delete as DeleteIcon, Plus } from '@icon-park/react';
import { getFixedHuapuLink, normalizeRelatedLinksData } from '../../config/relatedLinks.config';
import './styles/RelatedLinks.css';

function RelatedLinks({ data, onUpdate }) {
  const normalizedData = normalizeRelatedLinksData(data);
  const links = normalizedData.links || [];
  const layout = normalizedData.layout || 'grid';
  const cs = normalizedData.cardStyle || {};
  const logoSize = Number(normalizedData.logoSize || (layout === 'vertical-card' ? 72 : 36));

  const handleDeleteLink = (index) => {
    const nextLinks = links.filter((_, currentIndex) => currentIndex !== index);
    onUpdate({ ...normalizedData, links: nextLinks });
  };

  const handleUpdateLink = (index, field, value) => {
    const nextLinks = links.map((link, currentIndex) => (
      currentIndex === index ? { ...link, [field]: value } : link
    ));
    onUpdate({ ...normalizedData, links: nextLinks });
  };

  const handleAddLink = () => {
    const maxOrder = links.reduce((max, link) => Math.max(max, Number(link.order) || 0), 0);
    const nextLinks = [
      ...links,
      {
        enabled: true,
        icon: '',
        name: '',
        url: '',
        order: maxOrder + 1
      }
    ];
    onUpdate({ ...normalizedData, links: nextLinks });
  };

  return (
    <div className="related-links-container">
      <h3 className="template-title">相关链接</h3>

      {/* 布局设置区域 */}
      <div className="config-section">
        <div className="config-section-header">
          <span className="config-section-title">布局设置</span>
        </div>
        <div className="config-section-body">
          <div className="config-row">
            <label className="config-label">布局方式</label>
            <select 
              className="config-select"
              value={layout} 
              onChange={(e) => onUpdate({ ...normalizedData, layout: e.target.value })}
            >
              <option value="grid">网格</option>
              <option value="vertical-card">纵向卡片</option>
              <option value="horizontal-row">横向行</option>
            </select>
          </div>
          <div className="config-row">
            <label className="config-label">Logo尺寸</label>
            <div className="config-input-group">
              <input 
                type="number" 
                className="config-input-number"
                min="16" 
                max="128" 
                value={logoSize} 
                onChange={(e) => onUpdate({ ...normalizedData, logoSize: Number(e.target.value) })} 
              />
              <span className="config-unit">px</span>
            </div>
          </div>
        </div>
      </div>

      {/* 样式设置区域 */}
      <div className="config-section">
        <div className="config-section-header">
          <span className="config-section-title">样式设置</span>
        </div>
        <div className="config-section-body">
          <div className="config-grid">
            <div className="config-item">
              <label className="config-label-small">卡片背景</label>
              <div className="color-input-wrapper">
                <input 
                  type="color" 
                  className="config-color"
                  value={cs.bgColor || '#ffffff'} 
                  onChange={(e) => onUpdate({ ...normalizedData, cardStyle: { ...cs, bgColor: e.target.value } })} 
                />
                <span className="color-value">{cs.bgColor || '#ffffff'}</span>
              </div>
            </div>
            <div className="config-item">
              <label className="config-label-small">文字颜色</label>
              <div className="color-input-wrapper">
                <input 
                  type="color" 
                  className="config-color"
                  value={cs.textColor || '#202124'} 
                  onChange={(e) => onUpdate({ ...normalizedData, cardStyle: { ...cs, textColor: e.target.value } })} 
                />
                <span className="color-value">{cs.textColor || '#202124'}</span>
              </div>
            </div>
            <div className="config-item">
              <label className="config-label-small">边框色</label>
              <div className="color-input-wrapper">
                <input 
                  type="color" 
                  className="config-color"
                  value={cs.borderColor || '#e8eaed'} 
                  onChange={(e) => onUpdate({ ...normalizedData, cardStyle: { ...cs, borderColor: e.target.value } })} 
                />
                <span className="color-value">{cs.borderColor || '#e8eaed'}</span>
              </div>
            </div>
            <div className="config-item">
              <label className="config-label-small">边框宽</label>
              <div className="config-input-group">
                <input 
                  type="number" 
                  className="config-input-number"
                  min="0" 
                  max="8" 
                  value={cs.borderWidth ?? 1} 
                  onChange={(e) => onUpdate({ ...normalizedData, cardStyle: { ...cs, borderWidth: Number(e.target.value) } })} 
                />
                <span className="config-unit">px</span>
              </div>
            </div>
            <div className="config-item">
              <label className="config-label-small">圆角</label>
              <div className="config-input-group">
                <input 
                  type="number" 
                  className="config-input-number"
                  min="0" 
                  max="24" 
                  value={cs.radius ?? 12} 
                  onChange={(e) => onUpdate({ ...normalizedData, cardStyle: { ...cs, radius: Number(e.target.value) } })} 
                />
                <span className="config-unit">px</span>
              </div>
            </div>
            <div className="config-item">
              <label className="config-checkbox-label">
                <input 
                  type="checkbox" 
                  className="config-checkbox"
                  checked={cs.shadow !== false} 
                  onChange={(e) => onUpdate({ ...normalizedData, cardStyle: { ...cs, shadow: e.target.checked } })} 
                />
                <span>阴影效果</span>
              </label>
            </div>
          </div>
        </div>
      </div>

      {/* 链接列表区域 */}
      <div className="links-section">
        <div className="links-section-header">
          <span className="links-section-title">链接列表</span>
          <span className="links-count">共 {links.length} 个链接</span>
        </div>
        <div className="links-table">
          <div className="links-table-header">
            <div className="col-checkbox"></div>
            <div className="col-icon">示例图片</div>
            <div className="col-name">示例名称</div>
            <div className="col-url">链接</div>
            <div className="col-order">排序</div>
            <div className="col-action">操作</div>
          </div>

        {links.map((link, index) => (
          <div key={index} className="links-table-row">
            <div className="col-checkbox">
              <input
                type="checkbox"
                checked={link.enabled !== false}
                className="link-checkbox"
                onChange={(e) => handleUpdateLink(index, 'enabled', e.target.checked)}
              />
            </div>
            <div className="col-icon">
              <img src={(link.icon || getFixedHuapuLink().icon)} alt={link.name || '相关链接'} className="link-icon-img" />
            </div>
            <div className="col-name">
              <input
                type="text"
                className="link-input"
                value={link.name || ''}
                placeholder="请输入链接名称"
                onChange={(e) => handleUpdateLink(index, 'name', e.target.value)}
              />
            </div>
            <div className="col-url">
              <input
                type="url"
                className="link-input"
                value={link.url || ''}
                placeholder="请输入链接地址"
                onChange={(e) => handleUpdateLink(index, 'url', e.target.value)}
              />
            </div>
            <div className="col-order">
              <input
                type="number"
                className="order-input"
                value={link.order || index + 1}
                min="1"
                onChange={(e) => handleUpdateLink(index, 'order', Number(e.target.value) || index + 1)}
              />
            </div>
            <div className="col-action">
              <button
                type="button"
                className="delete-link-btn"
                onClick={() => handleDeleteLink(index)}
              >
                <DeleteIcon theme="outline" size={14} fill="#c62828" strokeWidth={3} />
                删除
              </button>
            </div>
          </div>
        ))}
        </div>

        <button
          type="button"
          className="add-link-btn"
          onClick={handleAddLink}
        >
          <span className="add-icon">
            <Plus theme="outline" size={16} fill="currentColor" strokeWidth={3} />
          </span>
          增加链接
        </button>
      </div>
    </div>
  );
}

export default RelatedLinks;
